module.exports = __webpack_public_path__ + "static/media/comp-crushing-s.8317bcb9.webp";